class exports.MapSidebar
    constructor: (map = null, element = null, tabs = true) ->
        @map = map

        if not element
            element = $($('.map_sidebar')[0])

        @element = element

        @isOpen = true
        #left margin when we are open
        @openLeft = 0
        # left margin when we're closed
        @closeLeft = -298

        @element.find('.map_sidebar_hide').click () =>
            @toggle()

        if tabs
            @element.delegate '.nav-tabs a', 'click', (e) ->
                if $(this).attr('ui-sref')
                    return

                e.preventDefault()
                $(this).tab('show')

                handler = $(this).data('handler') or $(this).html()
                sub = App.current_page.createSubHandler handler
                if sub
                    sub.init()


        $(window).on 'resize', debounce(() =>
            @resizeContent(false)
        )


    contentDiv: () =>
        return @element.find('.sidebar_content')

    messageWriter: () =>
        # Force initialize it
        elem = @element.find('.sidebar_message_writer')
        if elem.length > 0
            elem.message_writer()
        return elem

    toggle: () =>
        left = if @isOpen then @closeLeft else @openLeft
        icon = if @isOpen then 'fa fa-chevron-right' else 'fa fa-chevron-left'

        @isOpen = not @isOpen

        if @isOpen
            @contentDiv().parent().css 'display', 'block'

        @element.animate(
            { marginLeft: "#{left}px" }
            {
                duration: 200
                step: () =>
                    @resizeMap(left)
                    @resizeContent()
                complete: () =>
                    # ensure one last resize to get it
                    # absolutely in position
                    @resizeMap(left)
                    @resizeContent()
                    if not @isOpen
                        @contentDiv().parent().css 'display', 'none'
            }
        )

        @element.find('.map_sidebar_hide').find('i').attr 'class', icon



    open: () ->
        if not @isOpen
            @toggle()


    close: () ->
        if @isOpen
            @toggle()


    ###
    #
    # This function ensures correct sizing for map and sidebar.
    # When the window is resized or the sidebar is toggled, we need to
    # fix several things, including a lot of height settings, and the width/placement
    # of the map canvas
    #
    ###
    resizeMap: (left_margin) =>
        if not @map?
            return

        sidebarWidth = @element.outerWidth(true)
        sidebarLeftOffset = @element.offset().left
        effectiveWidth = sidebarWidth + sidebarLeftOffset

        $('#map_canvas').css
            left: effectiveWidth + 'px'
            right: '0px'

        # forces map canvas to readjust it's size
        # This should *probably* be debounced
        @map.invalidateSize()

        return

    ###
    #
    # This function ensures correct sizing for fullpage content and sidebar.
    # We want to acuatlly resize the fullpage content instead of just shifting
    # it to the left.
    #
    ###
    resizeContent: (triggerWindowResize = true) =>
        return if @element.is ':hidden'

        fullpage_content = $('#map_fullpage').first()
        if not fullpage_content?
            return

        sidebarWidth = @element.outerWidth(true)
        sidebarLeftOffset = @element.offset().left
        effectiveWidth = sidebarWidth + sidebarLeftOffset
        window_width = $(window).width()

        fullpage_content.width(window_width - effectiveWidth).css
            left: effectiveWidth + 'px'

        if triggerWindowResize
            setTimeout () =>
                $(window).trigger('resize')
            , 0

        return
